import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BrowserModule} from "@angular/platform-browser";
import { BootstrapComponent } from './components/bootstrap/bootstrap.component';
import {publicRoutes} from "./public.routes";
import {RouterModule} from "@angular/router";
import { ContactsComponent } from './components/contacts/contacts.component';
import { EmailPreferencesComponent } from './components/email-preferences/email-preferences.component';
import { EmailReceivedComponent } from './components/email-received/email-received.component';
import { HomeComponent } from './components/home/home.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PreferenceUpdateComponent } from './components/preference-update/preference-update.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { EmailPreferencesV2Component } from './components/email-preferences-v2/email-preferences-v2.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@NgModule({
  declarations: [
    BootstrapComponent,
    ContactsComponent,
    EmailPreferencesComponent,
    EmailPreferencesV2Component,
    EmailReceivedComponent,
    HomeComponent,
    PageNotFoundComponent,
    PreferenceUpdateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    HttpClientModule,
    RouterModule.forRoot(publicRoutes)
  ],
  bootstrap: [BootstrapComponent]
})
export class PublicModule { }